export var CmdType;
(function (CmdType) {
    CmdType[CmdType["Call"] = 0] = "Call";
    CmdType[CmdType["Set"] = 1] = "Set";
    CmdType[CmdType["Get"] = 2] = "Get";
    CmdType[CmdType["Constructor"] = 3] = "Constructor";
})(CmdType || (CmdType = {}));
export var SerializeType;
(function (SerializeType) {
    SerializeType[SerializeType["Primitive"] = 0] = "Primitive";
    SerializeType[SerializeType["Object"] = 1] = "Object";
})(SerializeType || (SerializeType = {}));
export var ArgEnum;
(function (ArgEnum) {
    ArgEnum[ArgEnum["Primitive"] = 0] = "Primitive";
    ArgEnum[ArgEnum["Object"] = 1] = "Object";
    ArgEnum[ArgEnum["Callback"] = 2] = "Callback";
    ArgEnum[ArgEnum["ObjectProperty"] = 3] = "ObjectProperty";
})(ArgEnum || (ArgEnum = {}));
